function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0625 0.515625L11.4844 0.9375C12 1.45312 12 2.29688 11.4844 2.8125L10.9219 3.375L8.625 1.07812L9.1875 0.515625C9.70312 0 10.5469 0 11.0625 0.515625ZM4.03125 5.67188L7.82812 1.875L10.125 4.17188L6.32812 7.96875C6.1875 8.10938 6.02344 8.22656 5.83594 8.27344L3.75 8.97656C3.53906 9.04688 3.32812 9 3.16406 8.83594C3.02344 8.69531 2.95312 8.46094 3.02344 8.25L3.72656 6.1875C3.79688 5.97656 3.89062 5.8125 4.03125 5.67188ZM2.25 1.5H4.5C4.92188 1.5 5.25 1.82812 5.25 2.25C5.25 2.67188 4.92188 3 4.5 3H2.25C1.82812 3 1.5 3.32812 1.5 3.75V9.75C1.5 10.1719 1.82812 10.5 2.25 10.5H8.25C8.67188 10.5 9 10.1719 9 9.75V7.5C9 7.07812 9.32812 6.75 9.75 6.75C10.1719 6.75 10.5 7.07812 10.5 7.5V9.75C10.5 10.9922 9.49219 12 8.25 12H2.25C1.00781 12 0 10.9922 0 9.75V3.75C0 2.50781 1.00781 1.5 2.25 1.5Z",
  fill: "#FFFFFF"
});

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.fe8cb3e0.svg";
export { ForwardRef as ReactComponent };